import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';

const API = environment.API;
@Injectable({
  providedIn: 'root'
})
export class shipmentApiService {
  constructor(private http: HttpClient) {}

  get() {
    return this.http.get<any>(`${API}shipments`);
  }
}
